<template>
  <span class="tw-text-neutral-900 tw-text-2xl">
    <slot />
  </span>
</template>
